import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { HotFilterGroupConfiguration } from '@config/catalog/hotfilter-group-configurations';
import { useMemo } from 'react';
import useMarketingFiltersQuery from '@hooks/marketing-filters/use-marketing-filters-query';

// TODO: add tests
const useHotfiltersToDisplay = (configuration: HotFilterGroupConfiguration[]) => {
  const facets = useContextSelector(CatalogContext, (v) => v.facets);
  const staticFilterGroups = useContextSelector(CatalogContext, (v) => v.staticFilterGroups);
  const { dealMarketingFilter } = useMarketingFiltersQuery();

  const filterGroupsToDisplay = useMemo(() => {
    if (!facets) {
      return [];
    }

    const filterGroups = configuration.reduce((acc: HotFilterGroupConfiguration[], filterGroupConfiguration) => {
      // If the filter group is static, don't display it ( for brand, express delivery, direct shipping pages )
      if (filterGroupConfiguration.facet && staticFilterGroups[filterGroupConfiguration.facet]) {
        return acc;
      }

      // some filter groups have custom criteria to determine if they should be displayed
      if (!!filterGroupConfiguration.criteria) {
        if (filterGroupConfiguration.criteria(facets)) {
          return [...acc, filterGroupConfiguration];
        }
        return acc;
      }
      // otherwise if the facet exists in the facets object, display it
      if (filterGroupConfiguration.facet && facets[filterGroupConfiguration.facet]) {
        return [...acc, filterGroupConfiguration];
      }
      return acc;
    }, [] as HotFilterGroupConfiguration[]);

    // if we have a deal marketing filter, add it to the first position
    if (!!dealMarketingFilter && dealMarketingFilter.title) {
      const dealFilterGroupConfig = configuration.find((filterGroup) => filterGroup.facet === 'dealEligible');
      if (dealFilterGroupConfig && dealFilterGroupConfig.criteria(facets)) {
        return [
          { ...dealFilterGroupConfig, label: dealMarketingFilter.title },
          ...filterGroups.filter((x) => x.facet !== 'dealEligible'),
        ];
      }
    }
    return filterGroups;
  }, [facets, staticFilterGroups, dealMarketingFilter]);

  return { filterGroupsToDisplay };
};

export default useHotfiltersToDisplay;
